// extracted by mini-css-extract-plugin
module.exports = {"verfahrensart":"Insolvenz_verfahrensart__IfSmK","meta":"Insolvenz_meta__XcZGv","baustein":"Insolvenz_baustein___t4ni"};